export default "__VITE_ASSET__9272b120__"